import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const TriggerWrapper = styled.div`
  display: inline-block;
  cursor: pointer;
`;

export const StyledPopoverBox = styled.div<{
  $top: number;
  $right: number;
  $visible: boolean;
}>`
  position: absolute;
  top: ${({ $top: top }) => top}px;
  right: ${({ $right: right }) => right}px;
  background-color: ${theme.colors.white};
  border-radius: 8px;
  padding: 12px;
  box-shadow:
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);
  opacity: ${({ $visible: visible }) => (visible ? 1 : 0)};
  transform: ${({ $visible: visible }) =>
    visible ? "scale(1)" : "scale(0.95)"};
  transition:
    opacity 200ms ease,
    transform 200ms ease;
  pointer-events: ${({ $visible: visible }) => (visible ? "auto" : "none")};
`;

export const PopoverArrow = styled.div`
  position: absolute;
  left: 77%;
  top: -4px;
  width: 10px;
  height: 10px;
  background-color: ${theme.colors.white};
  box-shadow: -2px -2px 3px -2px #4a4a4f33;
  transform: rotateZ(45deg);
`;
